import * as React from "react";
import "../stylesheets/components/error_msg.scss";
const Errormsg = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "error-msg" },
            React.createElement("div", { className: "error-msg-wrapper" },
                React.createElement("div", null,
                    React.createElement("span", { className: "edel-icon-error-msg-icon  erroricon" })),
                React.createElement("div", { className: "error-msg-text" }, "Something went wrong")))));
};
export default Errormsg;
